import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import api, { apiError } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      });
  }, []);

  // Heartbeat: mantiene la presenza online e aggiorna permessi in tempo reale
  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => {
      api.get("/auth/me").then((res) => setUser(res.data)).catch((e) => console.debug("heartbeat auth/me failed", e));
    }, 45000);
    return () => clearInterval(t);
  }, [user?.id]);

  const login = useCallback(async (username, password) => {
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (err) {
      return { ok: false, error: apiError(err) };
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, logout }), [user, login, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

